var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { PLAY_EVENT, VIDEO_NODE_EVENT, VIDEO_STATE } from '../enums';
import EvtEmitter from '../libs/event-emitter';
import SimpleDefer from '../libs/simple-defer';
import { Logger, logMethodCallDecoratorCreator } from '../util';
var logMethodCall = logMethodCallDecoratorCreator('OrgPreLoader');
/**
 * 执行预加载
 */
var OrgPreLoader = /** @class */ (function () {
    function OrgPreLoader(playerConfig) {
        var _a;
        this.playerConfig = playerConfig;
        this.deferInner = new SimpleDefer();
        this.logger = new Logger(playerConfig.instanceId, 'OrgPreLoader');
        this.evtMaps = (_a = {},
            _a[VIDEO_NODE_EVENT.STATE_CHANGE] = this.firstLoadStateChangeHandler.bind(this),
            _a[VIDEO_NODE_EVENT.ERROR] = this.errorHandler.bind(this),
            _a);
    }
    Object.defineProperty(OrgPreLoader.prototype, "promise", {
        get: function () {
            return this.deferInner.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrgPreLoader.prototype, "videoInfo", {
        get: function () {
            return this.videoInfoInner;
        },
        enumerable: false,
        configurable: true
    });
    OrgPreLoader.prototype.getVideoNode = function () {
        var _a;
        return (_a = this.videoInfoInner) === null || _a === void 0 ? void 0 : _a.extraVars.preloadVideoNode;
    };
    OrgPreLoader.prototype.errorHandler = function (e) {
        this.preloadFail(e.data.videoInfo.error);
    };
    OrgPreLoader.prototype.firstLoadStateChangeHandler = function (e) {
        if (e.data.new === VIDEO_STATE.CANPLAY) {
            this.preloadSucc();
        }
    };
    OrgPreLoader.prototype.preloadSucc = function () {
        this.logger.log("preload url ready>>>>>> uid=".concat(this.videoInfoInner.uid));
        this.clearInner(true);
        this.evtDispatcher.emit(PLAY_EVENT.PRELOAD_VIDEONODE_OVER, { videoInfo: this.videoInfoInner });
        this.deferInner.resolve();
    };
    OrgPreLoader.prototype.preloadFail = function (error) {
        this.logger.log("preload url fail>>>>>> uid: ".concat(this.videoInfoInner.uid));
        this.clearInner();
        this.evtDispatcher.emit(PLAY_EVENT.PRELOAD_VIDEONODE_ERROR, { videoInfo: this.videoInfoInner });
        this.videoInfoInner.error = error;
        this.deferInner.reject(error);
    };
    OrgPreLoader.prototype.setVideoNodeEvents = function (value) {
        var _this = this;
        var videoNode = this.getVideoNode();
        Object.keys(this.evtMaps).forEach(function (key) {
            if (value) {
                videoNode.on(key, _this.evtMaps[key]);
            }
            else {
                videoNode.off(key, _this.evtMaps[key]);
            }
        });
    };
    OrgPreLoader.prototype.load = function (isFirstLoad, evtDispatcher, videoInfo, extra) {
        this.videoInfoInner = videoInfo;
        this.evtDispatcher = evtDispatcher;
        this.setVideoNodeEvents(true);
        this.logger.log("load(), isFirstLoad=".concat(isFirstLoad));
        this.getVideoNode().load(videoInfo, extra);
    };
    OrgPreLoader.prototype.clearInner = function (keepLoadedData, emitEvt) {
        if (!this.videoInfoInner) {
            return;
        }
        var videoNode = this.getVideoNode();
        if (!videoNode) {
            return;
        }
        this.logger.log("clear(), uid=".concat(this.videoInfoInner.uid, "/keep=").concat(keepLoadedData));
        this.setVideoNodeEvents(false);
        if (!keepLoadedData) {
            this.videoInfoInner.extraVars.preloadVideoNode = null;
            videoNode.stop();
        }
        if (emitEvt) {
            this.evtDispatcher.emit(PLAY_EVENT.PRELOAD_VIDEONODE_CLEAR, { videoInfo: this.videoInfoInner });
        }
    };
    OrgPreLoader.prototype.clear = function (keepLoadedData) {
        this.clearInner(keepLoadedData, true);
    };
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, EvtEmitter, Object, Object]),
        __metadata("design:returntype", void 0)
    ], OrgPreLoader.prototype, "load", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], OrgPreLoader.prototype, "clear", null);
    return OrgPreLoader;
}());
export default OrgPreLoader;
